import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Campaign } from '../../types/campaigns.models';
import { DonationType } from '../../types/donation-flow.models';

/** Valida el control donationType contra la campaña (o su flag isIndefinite). */
export function donationTypeAllowedByCampaign(
  campaign: Campaign | null
): ValidatorFn {
  const canAcceptRecurring = !!campaign?.isIndefinite;
  return donationTypeAllowed(canAcceptRecurring);
}

export function donationTypeAllowed(canAcceptRecurring: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as DonationType;
    if (value === DonationType.Recurring && !canAcceptRecurring) {
      return { recurringNotAllowed: true };
    }
    return null;
  };
}

/** Helper opcional para mostrar mensajes */
export function donationTypeErrorMessage(
  errors: ValidationErrors | null | undefined
): string {
  if (!errors) return '';
  if (errors['recurringNotAllowed'])
    return 'This campaign only accepts one-time donations.';
  return '';
}
